module.exports = __webpack_public_path__ + "static/media/sweet_view_7.d29a2838.jpg";